module.exports = function () {
    /*!
     * jQuery Mobile Orientation @VERSION
     * http://jquerymobile.com
     *
     * Copyright jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     */

    //>>label: Orientation support test
    //>>group: Core
    //>>description: Feature test for orientation

    $.extend( $.support, {
        orientation: "orientation" in window && "onorientationchange" in window
    } );

    return $.support;

};
